import { AvailabilityType } from "@app/models/enums/availability-type.enum";
import { BaseEntity } from "@app/models/rest/base-entity";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";

@HateoasResource("availabilityCodes")
export class AvailabilityCode extends BaseEntity {
  description: string;
  systemOnly: boolean;
  availabilityType: AvailabilityType;
}
